import moment from 'moment'
import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import { Modal } from 'semantic-ui-react'
import LoginService from '../../../../../../../services/api/login.service'
import PatientAccountService from '../../../../../../../services/api/patient-account.service'
import PatientService from '../../../../../../../services/api/patient.service'
import RoleService from '../../../../../../../services/api/role.service'
import ModalBox from '../../../../../../templates/components/ModalBox'
import Table2 from '../../../../../../templates/components/Table2'
import UserRolesAdd from '../user-roles-add/UserRolesAdd'
import UserRolesEdit from '../user-roles-edit/UserRolesEdit'
import ViewAccess from '../view-access/ViewAccess'


const UserRolesTable = (props) => {
    const [roles, setRoles] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [viewEdit, setViewEdit] = useState()
    const [selectedRole, setSelectedRole] = useState()
    const [statusModal, setStatusModal] = useState(false)
    const [viewAdd, setViewAdd] = useState()
    const [viewPerm, setViewPerm] = useState()
    const [masterRoles, setMasterRoles] = useState()
    const getRoles = () => {
        setIsLoader(true)
        let reqObj = {}
        if (props.practiceId) {
            reqObj.practiceId = props.practiceId
        }
        RoleService.find(reqObj)
            .then(res => {
                if (res?.data?.data) {
                    console.log(res.data.data)
                    setRoles(res.data.data)
                }
                setIsLoader(false)
            })
    }

    const getMasterRoles = () => {
        RoleService.getMasterRole()
        .then(res => { console.log(res); setMasterRoles(res.data.data.selectResponse) })
        .catch(err => console.log(err))
    }

    const activateRole = () => {
        RoleService.activateRole(selectedRole.id,props.practiceId)
            .then(res => {
                toast.success("Role is Activated")
                setStatusModal(false)
                return getRoles()
            })
    }
    const deactivateRole = () => {
        RoleService.deactivateRole(selectedRole.id,props.practiceId)
            .then(res => {
                toast.success("Role is Inactive")
                setStatusModal(false)
                return getRoles()
            })
    }
    const roleEnum = [
        {id: 1, title: 'Admin'},
        {id: 2, title: 'Front Desk'},
        {id: 3, title: 'Provider'},
        {id: 4, title: 'Call Center'},
        {id: 5, title: 'Book Keeper'},
    ]

    useEffect(() => {
        getRoles()
        getMasterRoles()
    }, [props.refresh])
    const columns = [
        {
            id: "roleName",
            Header: "Name",
            accessor: role=>role.roleName
        },
        {
            id: "description",
            Header: "Description",
            accessor: role=>role.description
        },
        {
            id: "masterRoleId",
            Header: "Master Role",
            accessor: (role)=>roleEnum.find(obj=>obj.id==role.masterRoleId)?.title
        },
        {
            id: "isActive",
            Header: "Status",
            accessor: (role, i) => role.isActive ? <span className='btn btn-success text-white w-100'>Active</span> : <span className='btn btn-danger text-white w-100'>Inactive</span>
        },
        {
            id: "actionPracticePatient",
            Header: "Action",
            disableSortBy: true, 
            textAlign: 'center',
            accessor: (role, i) => {
                return (

                    <div className='d-flex justify-content-center'>
                        <button className="p-0 ps-1 btn btn-primary" title="Edit role" onClick={e => { e.preventDefault(); setSelectedRole(role); return setViewEdit(true) }}><i className="icon pencil" /></button>
                        <button className="p-0 ps-1 btn btn-primary ms-1" title={role.isActive ? 'Deactivate role' : 'Activate role'} onClick={e => { e.preventDefault(); setSelectedRole(role); return setStatusModal(true) }}>{role.isActive ? <i className="icon dont" /> : <i className="icon check" />}</button>
                        <button className="p-0 ps-1 btn btn-primary ms-1" title='View Permissions' onClick={e => { e.preventDefault(); setSelectedRole(role); return setViewPerm(true) }}><i className="icon horizontal bars" /></button>
                    </div>
                )
            }
        }
    ]

   
    return (
        <div>
            <Table2 searchable export data={roles} columns={columns} loading={isLoader}
                extraButtons={[
                    {
                        className: 'btn btn-primary',
                        children: <i className='icon plus' />,
                        onClick: () => { setViewAdd(true) },
                        title: 'Add User Role'
                    }
                ]} />
            <ModalBox open={statusModal} onClose={() => setStatusModal(false)}>
                <div className='row d-flex justify-content-between align-items-center'>
                    <div className='col'>
                        {selectedRole?.isActive == 1 ? <p>Are you sure you want to deactivate role?</p> : <p>Are you sure you want to Activate this role?</p>}
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-primary' onClick={(e) => { e.preventDefault(); selectedRole?.isActive == 1 ? deactivateRole() : activateRole() }} >OK</button>
                        <button className="btn btn-secondary ms-3" onClick={(e) => { e.preventDefault(); setStatusModal(false) }}>Cancel</button>
                    </div>
                </div>
            </ModalBox>
            <ModalBox open={viewAdd} onClose={() => { setViewAdd(false) }} title="Add a User role">
                <UserRolesAdd practiceId={props.practiceId} onClose={() => { getRoles(); return setViewAdd(false) }} />
            </ModalBox>
            <ModalBox open={viewEdit} onClose={() => { setViewEdit(false) }} title="Edit a User role">
                <UserRolesEdit id={selectedRole?.id} practiceId={props.practiceId} onClose={() => { getRoles(); return setViewEdit(false) }} />
            </ModalBox>
            <ModalBox open={viewPerm} onClose={() => { setViewPerm(false) }} title={`Features for ${selectedRole?.roleName} role`}>
                {selectedRole && viewPerm ? <ViewAccess fromAdmin={props?.fromAdmin} role={selectedRole} practiceId={props.practiceId} id={selectedRole?.id} onClose={() => { setViewPerm(false) }} /> : null}
            </ModalBox>
        </div>
    )
}

export default UserRolesTable